import { useSelector } from "react-redux";

import { selectHasPermission } from "../Redux/authPermissions/authPermissionsSlice";

export const usePermission = (permissionKey) =>
  useSelector((state) => selectHasPermission(state, permissionKey));

export default usePermission;
